import moment from "moment";
import { getWeekDaysFromDateRange } from "@/utils/dates";
import { getFormattedDateTimeString } from "@/utils/dateTimeFormat";
import { FacilitySettingsModel } from "@/models/FacilitySettings";

export default {

  name: "ReportVisits",
  data() {
    return {
      startDate: moment().subtract(1, "week").toISOString().substring(0, 10),
      endDate: moment().toISOString().substring(0, 10),
      flexHeight: 250,
      picker: {
        start: false,
        end: false
      },
      eventsByIsStaffBooked: [],
      eventsPerVisitType: [],
      dailyCount: [],
      eventsByDate: []
    }
  },
  computed: {
    guestbookVisits() {
      return this.$store.state.guestbookModule.guestbook;
    },
    facility(): FacilitySettingsModel {
      return this.$store.state.facilityModule.selectedFacility;
    },
    formattedStartDate() {
      return moment(this.startDate).format(this.facility.dateFormat)
    },
    formattedEndDate() {
      return moment(this.endDate).format(this.facility.dateFormat)
    }
  },

  watch: {
    "guestbookVisits"(guestbookVisits) {
      console.log('reload report')
      this.eventsByDate = this.groupByDay(guestbookVisits)
      this.dailyCount = this.getDailyCount(guestbookVisits)
      this.eventsPerVisitType = this.getPerVisitType(guestbookVisits)
      this.eventsByIsStaffBooked = this.groupByIsStaffBooked(guestbookVisits)
    }
  },
  mounted() {
    this.$store.dispatch("getGuestbookVisits", {
      startDate: moment(this.startDate).startOf('day').toDate(),
      endDate: moment(this.endDate).endOf('day').toDate()
    });
  },
  methods: {
    routeToGuestbook() {
      this.$router.push("/reports");
    },
    getVisitsByDates() {
      this.$store.dispatch("getGuestbookVisits", {
        startDate: moment(this.startDate).startOf('day').toDate(),
        endDate: moment(this.endDate).endOf('day').toDate()
      });
    },
    getDailyCount(visits) {
      const types = visits.reduce(function (totals, visit) {
        const date = moment(visit.start)
          .startOf("day")
          .format("LL");
        !totals[date] ? (totals[date] = 1) : (totals[date] = totals[date] + 1);
        return totals;
      }, {});
      return types;
    },
    getVisitsPerResident(visits) {
      const types = visits.reduce(function (totals, visit) {
        !totals[visit.residentName]
          ? (totals[visit.residentName] = 1)
          : (totals[visit.residentName] = totals[visit.residentName] + 1);
        return totals;
      }, {});
      return types;
    },
    getPerVisitType(visits) {
      const types = visits.reduce(function (totals, visit) {
        !totals[visit.visitType]
          ? (totals[visit.visitType] = 1)
          : (totals[visit.visitType] = totals[visit.visitType] + 1);
        return totals;
      }, {});
      return types;
    },
    groupByDay(events) {
      const weekDays = getWeekDaysFromDateRange(moment(this.startDate), moment(this.endDate))
      const week = weekDays.reduce((o, key) => ({ ...o, [key]: undefined }), {})
      const types = events.reduce(function (totals, event) {
        const dayOfWeek = moment(event.start).format("dddd");
        !week[dayOfWeek] ? (week[dayOfWeek] = 1) : (week[dayOfWeek] = totals[dayOfWeek] + 1);
        return week;
      }, {});
      return types;
    },
    groupByIsStaffBooked(visits) {
      const types = visits.reduce(function (totals, visit) {
        const text = visit?.isStaffBooked ? this?.$t('GeneralTranslations.Staff') : this?.$t('GeneralTranslations.Family');
        !totals[text] ? (totals[text] = 1) : (totals[text] = totals[text] + 1);
        return totals;
      }, {});
      return types;
    },
    formattedDateTimeString(date: Date, addYears: boolean, addTime: boolean) {
      if(!this.facility) return ''

      return getFormattedDateTimeString(date, this.facility.dateFormat, addTime?this.facility.timeFormat: null, addYears);
    },
  }
}
